export const Config = {
  // Rendering settings
  RENDER_WIDTH: window.innerWidth,
  RENDER_HEIGHT: window.innerHeight,
  CLEAR_COLOR: 0x87ceeb, // Sky blue
  FOV: 75,
  NEAR_PLANE: 0.5,
  FAR_PLANE: 2000,
  
  // Camera settings
  CAMERA_MOVE_SPEED: 15,
  CAMERA_ROTATE_SPEED: 0.002,
  CAMERA_ZOOM_SPEED: 2,
  CAMERA_MIN_HEIGHT: 3,
  CAMERA_MAX_HEIGHT: 100,
  CAMERA_DEFAULT_HEIGHT: 20,
  
  // First-person camera settings
  FPS_CAMERA: {
    PLAYER_HEIGHT: 1.8,
    WALK_SPEED: 5,
    RUN_SPEED: 10,
    JUMP_VELOCITY: 10,
    GRAVITY: 30,
    HEAD_BOB_AMOUNT: 0.05,
    HEAD_BOB_SPEED: 10,
    RUNNING_HEAD_BOB_AMOUNT: 0.15,
    RUNNING_HEAD_BOB_SPEED: 15
  },
  
  // Scene settings
  TERRAIN_SIZE: 200,
  TERRAIN_RESOLUTION: 1,
  
  // Lighting settings
  DIRECTIONAL_LIGHT_COLOR: 0xffffff,
  DIRECTIONAL_LIGHT_INTENSITY: 1.0,
  AMBIENT_LIGHT_COLOR: 0x404040,
  AMBIENT_LIGHT_INTENSITY: 0.5,
  
  // Shadow settings
  SHADOW_MAP_SIZE: 2048,
  SHADOW_CAMERA_SIZE: 100,
  
  // Debug settings
  SHOW_FPS: true,
  SHOW_DEBUG_INFO: false,
  SHOW_AXES_HELPER: false,
  AXES_HELPER_SIZE: 10,

  // Spatial partitioning settings
  QUADTREE_CAPACITY: 8, // Max objects per node before subdivision
  QUADTREE_DEBUG_MAX_DEPTH: 6, // Maximum depth to render for debug visualization
  QUADTREE_DEBUG_ENABLED: true, // Whether to show quadtree by default

  // LOD system settings
  LOD_HIGH_DISTANCE: 60, // Distance threshold for high detail (was 30)
  LOD_MEDIUM_DISTANCE: 100,
  LOD_ENABLED: true, // Whether LOD system is enabled
  LOD_UPDATE_FREQUENCY: 15, // Only update LOD every N frames

  // Static object performance settings
  ENABLE_INSTANCING: true,
  STATIC_OBJECT_COUNT: {
    TREES: 100,    // Reduced from 100
    ROCKS: 50,    // Reduced from 50
    BUSHES: 50    // Reduced from 50
  },

  // Toaster pool configuration
  POOL_SIZES: {
    SMALL_TOASTER: 100,  // Size of small toaster pool
    MEDIUM_TOASTER: 60,  // Size of medium toaster pool
    LARGE_TOASTER: 30    // Size of large toaster pool
  },

  // Level system settings
  LEVEL_SYSTEM: {
    COUNTDOWN_TIME: 5.0, // Seconds between waves
    LEVEL_COMPLETE_DELAY: 3.0, // Seconds between levels
    ENABLE_UI: true // Whether to enable the level UI
  },

  // Economy system settings
  ECONOMY_SYSTEM: {
    STARTING_GOLD: 100,
    TOWER_COST: 50,
    GUN_COST_PER_SHOT: 5,
    TOASTER_REWARDS: {
      'SMALL': 10,
      'MEDIUM': 25,
      'LARGE': 50
    }
  },

  // Game system settings
  GAME_SYSTEM: {
    STARTING_LOAF_HEALTH: 40,
    LOAF_DAMAGE_PER_HIT: 2,
    GAME_OVER_THRESHOLD: 0,
    ENABLE_GAME_SCREENS: true
  },
  
  // Level definitions
  LEVELS: [
    {
      name: "Level 1",
      waves: [
        {
          groups: [
            { toasterType: 'SMALL', count: 50, spawnDelay: 0.2, spawnPosition: { x: -40, z: -40 }, spawnAreaRadius: 10 }
          ]
        },
        {
          groups: [
            { toasterType: 'SMALL', count: 20, spawnDelay: 0.2, spawnPosition: { x: -40, z: 40 }, spawnAreaRadius: 15 },
            { toasterType: 'MEDIUM', count: 10, spawnDelay: 0.5, spawnPosition: { x: 40, z: -40 }, spawnAreaRadius: 15 }
          ]
        },
        {
          groups: [
            { toasterType: 'SMALL', count: 80, spawnDelay: 0.2, spawnPosition: { x: 40, z: 40 }, spawnAreaRadius: 15 },
            { toasterType: 'MEDIUM', count: 40, spawnDelay: 0.5, spawnPosition: { x: -40, z: 0 }, spawnAreaRadius: 15 },
            { toasterType: 'LARGE', count: 20, spawnDelay: 0.8, spawnPosition: { x: 0, z: -40 }, spawnAreaRadius: 15 }
          ]
        }
      ]
    }
  ],
  
  // Dynamic object performance settings
  DYNAMIC_OBJECT_SETTINGS: {
    QUADTREE_UPDATE_THRESHOLD: 1.0,    // Min distance moved before updating quadtree
    BATCH_UPDATE_SIZE: 50,             // Max number of objects to update per frame
    UPDATE_INTERVAL_MS: 500,           // Milliseconds between full quadtree rebuilds
    MAX_PREDICTION_FRAMES: 5,          // Number of frames to predict ahead for collision
    
    // Priority distance thresholds (squared distances to avoid sqrt calculations)
    PRIORITY_NEAR_DISTANCE_SQ: 3600,   // 60² - Objects closer than this get HIGH priority
    PRIORITY_MEDIUM_DISTANCE_SQ: 10000, // 100² - Objects closer than this get MEDIUM priority
    PRIORITY_ADJUST_INTERVAL: 120,     // Frames between priority adjustments
    
    // Visibility settings
    DORMANT_WHEN_OFFSCREEN: false,      // Set off-screen objects to dormant
    REDUCE_PRIORITY_WHEN_DISTANT: true // Reduce priority for distant objects
  }
}
